import React from 'react'
import { DEFAULTAVATAR } from 'Constants';
import AccountStatusInfo from './AccountStatusInfo';
import RenderProfessionalDetailsGrid from './RenderProfessionalDetailsGrid';

// Shared look for the attorney / firm / funder "Profile" tab:
// header card (photo, name, status, edit button), any pending review,
// then the details in white cards on the cream page.
export function ProfileCard({ title, note, children }) {
  return (
    <div className='bg-white border border-navy/[.12] rounded-lg'>
      {(title || note) &&
        <div className='px-4 pt-4 lg:px-6 lg:pt-5'>
          {title && <div className='font-spectral font-normal text-[18px] leading-[1.3] text-navy'>{title}</div>}
          {note && <div className='font-plexsans text-[12.5px] leading-[1.4] text-navy/[.55] mt-1'>{note}</div>}
        </div>}
      <div className='px-4 pb-1 pt-1 lg:px-6'>{children}</div>
    </div>
  );
}

function ProfileDetailsView({
  title, avatar, showAvatar = false, verified = false,
  isUserVerified, updatesSent,
  buttonName, onEdit, hideButton = false,
  updates,          // pending-review block (SeeUpdatesMadeOnAccount), if any
  sections = [],    // [{ title, note, data }]
  children,         // extra cards after the sections
}) {
  const button = !hideButton && buttonName &&
    <button type='button' onClick={onEdit}
      className='flex-none w-full lg:w-auto font-plexsans font-semibold text-[13.5px] leading-none text-ivory bg-brass hover:bg-brassDark border-0 rounded-md py-3 px-5 cursor-pointer'>
      {buttonName}
    </button>;

  return (
    <div className='w-full min-h-full bg-cream px-4 py-5 lg:px-10 lg:py-[34px] flex flex-col gap-4 lg:gap-5 font-plexsans'>
      <div className='bg-white border border-navy/[.12] rounded-lg p-4 lg:p-6 flex flex-col lg:flex-row lg:items-start gap-4 lg:gap-6'>
        <div className='flex items-start gap-4 flex-1 min-w-0'>
          {showAvatar &&
            <img src={avatar || DEFAULTAVATAR} alt=''
              className={`flex-none w-14 h-14 lg:w-[72px] lg:h-[72px] rounded-full object-cover bg-cream ring-2 ring-offset-2 ${verified ? 'ring-brass' : 'ring-navy/[.15]'}`} />}
          <AccountStatusInfo isUserVerified={isUserVerified} updatesSent={updatesSent} title={title} />
        </div>
        {button}
      </div>

      {updates && <div className='bg-white border border-navy/[.12] rounded-lg p-4 lg:p-6'>{updates}</div>}

      {sections.filter(Boolean).map((s) => (
        <ProfileCard key={s.title} title={s.title} note={s.note}>
          <RenderProfessionalDetailsGrid data={s.data} />
        </ProfileCard>
      ))}

      {children}
    </div>
  );
}

export default ProfileDetailsView
